// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "高等数学（一）",
      "tec": "计倩",
      "week": "6-10,12-18周",
      "add": "教学楼A座221电力"
    },
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-10,12-18周",
      "add": "教学楼A座225电力"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26新核2-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26新核1-2",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "26新核2-4",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "26新核2-3",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "26新核1-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "教学楼D座124新能"
      },
      {
        "sub": "26新核2-2",
        "tec": "齐越",
        "week": "6-17周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "军事理论",
      "tec": "黄小刚",
      "week": "6-10周",
      "add": "教学楼C座215教务"
    },
    0
  ],
  "2": [
    {
      "sub": "人工智能与计算思维",
      "tec": "宋丹茹",
      "week": "6,8,10,12,14周",
      "add": "（7,9,13,15-17周[01-02节]）实训楼C座103"
    },
    {
      "sub": "心理健康与调适",
      "tec": "王丽娜",
      "week": "6-10,12-16周",
      "add": "实训E223悦动团体活动室"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "6-9周",
      "add": "教学楼C座213教务"
    }
  ],
  "3": [
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-10,12-18周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "高等数学（一）",
      "tec": "计倩",
      "week": "6-10,12-18周",
      "add": "教学楼A座322电力"
    },
    0,
    {
      "sub": "健康教育",
      "tec": "韩吉哲",
      "week": "6-17周",
      "add": "（6-17周[07-08节]）教学楼C座306教务"
    },
    0
  ],
  "4": [
    0,
    [
      {
        "sub": "大学英语（一）",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26新核2-4",
        "tec": "齐越",
        "week": "6-17周",
        "add": "教学楼A座126信息"
      },
      {
        "sub": "26新核1-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "教学楼D座120新能"
      },
      {
        "sub": "26新核1-2",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "教学楼D座124新能"
      },
      {
        "sub": "26新核2-1",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "教学楼D座217经管"
      },
      {
        "sub": "26新核2-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26新核2-2",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    {
      "sub": "人工智能与计算思维",
      "tec": "宋丹茹",
      "week": "6,8,10,12,14周",
      "add": "教学楼B座420能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "何芳",
      "week": "6-9周",
      "add": "教学楼C座215教务"
    },
    0
  ],
  "5": [
    0,
    {
      "sub": "高等数学（一）",
      "tec": "计倩",
      "week": "6-10,12-18周",
      "add": "教学楼A座322电力"
    },
    {
      "sub": "核电技术与控制工程专业导论",
      "tec": "李凡周文平",
      "week": "6-10,12-14周",
      "add": "教学楼B座423能动"
    },
    {
      "sub": "军事理论",
      "tec": "黄小刚",
      "week": "6-10周",
      "add": "教学楼C座112教务"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
